import { SectionComponents } from '~/types/components'

/**
 * Resolves a section component based on the provided block type.
 *
 * @param {SectionComponents} block - The block type to resolve the component for.
 * @returns {Component | undefined} The resolved component or undefined if the block type is invalid or the component does not exist.
 *
 */
export default function () {
  const resolveSectionComponent = (block: SectionComponents) => {
    if (!block) {
      return
    }

    const componentName = Object.entries(SectionComponents).find(([key, _]) => key === block)?.[1]

    if (!componentName) {
      console.error(`Component for model type [${block}] does not exist.`)
      return
    }
    return resolveComponent(componentName)
  }

  return {
    resolveSectionComponent
  }
}
